<template>
    <div id="app" data-v-app="">
        <div class="d-flex justify-content-center spinner-border text-primary spinner-position form" v-if="loading"></div>
        <div class="spinner" v-if='loading'></div>
        <div class="row-wrapper" v-if="!loading">
            <div class="col-8">
                <div class="image">
                </div>
                <div class="row-wrapper" id="picture" :style="backgroundStyle">
                </div>
            </div>
            <div class="col-4">
                <div id="login-card" class="card-body">
                    <div class="logo-brand">
                        <img v-if="!this.merchant_id" id="logo-brand-omnih" :src="setCorporateLogo" alt="logo">
                        <img v-else id="logo-brand" :src="branchLogo" alt="logo">
                        <hr class="separator">
                    </div>
                    
                    <label v-if="registerState" style="color: red; text-align: center">
                        {{ registerMessage ? 'Successfully created an account and can log in using the new registered email password' : 'Please wait for merchant verify your account request' }}
                        </label>
                    <o-form id="form-login" class="form-login" v-if="!isOtpMode">
                        <o-form-group title="Email" name="email">
                            <o-input-text name="name" v-model="email" type="email" :required="true" placeholder="email"/>
                        </o-form-group>

                        <o-form-group title="Password" name="password" @keyup.enter="submitLogin()">
                            <o-input-text name="password" v-model="password" :type="showPassword ? 'text' : 'password'" :required="true"
                                placeholder="password"/>
                        </o-form-group>
                        <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" id="showPasswordCheckbox" v-model="showPassword">
                            <label class="form-check-label" for="showPasswordCheckbox">
                                Show Password
                            </label>
                        </div>
                        <div class="d-flex flex-column align-items-end gap-2 mb-2">
                            <router-link :to="forgotPasswordLink">
                                <small>Forgot password?</small>
                            </router-link>
                            <a href="javascript:void(0);" class="otp-link" @click="switchToOtpMode">
                                Login with OTP
                            </a>
                        </div>

                        <div v-if="validation" class="custom-alert">
                            <div class="alert-content">
                              <span class="alert-icon">&#9888;</span>
                              <p>{{ passwordErrorMessage || 'Invalid email or password' }}</p>
                            </div>
                          </div>

                        <div v-if="validationEntity" class="custom-alert">
                            <div class="alert-content">
                                <span class="alert-icon">&#9888;</span>
                              <p>Invalid entity</p>
                            </div>
                        </div>

                        <div v-if="validationMemberOnly" class="custom-alert">
                            <div class="alert-content">
                                <span class="alert-icon">&#9888;</span>
                              <p>Invalid level, please login with member only</p>
                            </div>
                        </div>

                        <div class="custom-alert" v-if="otpErrorMessage">{{ otpErrorMessage }}</div>
                    </o-form>

                    <o-form id="form-otp" v-if="isOtpMode" @submitted="handleOtpFormSubmit">
                        <o-form-group title="Email" name="otp-email" v-if="!otpRequested">
                            <o-input-text v-model="otpEmail" type="email" :required="true" placeholder="Enter your email" @enter="requestOtp"/>
                        </o-form-group>

                        <div v-if="!otpRequested" class="d-flex justify-content-center mt-3">
                            <o-button type="button" class="otp-button" @click="requestOtp">Send OTP</o-button>
                        </div>

                        <div v-if="otpRequested" class="d-flex flex-column gap-3 mt-3">
                            <o-form-group title="Enter OTP" name="otp">
                                <o-input-digit v-model="otp" :required="true" placeholder="Enter OTP"/>
                            </o-form-group>

                            <div class="d-flex flex-column align-items-center gap-2">
                                <div v-if="showCountdown">
                                    <span class="countdown-text">{{ formattedTime }}</span>
                                </div>
                                <o-button type="button" class="resend-button" v-if="!showCountdown" @click="resendOTP">Resend OTP</o-button>
                            </div>

                            <div class="d-flex justify-content-center">
                                <o-button type="button" class="otp-button" @click="submitOtp">Submit OTP</o-button>
                            </div>
                            <div v-if="otpRequested && otpEmail" class="text-center mt-2">
                                <p class="custom-label">
                                    *Please check your <strong>{{ otpEmail }}</strong> mailbox to get the OTP code.
                                </p>
                            </div>
                        </div>
                        <div v-if="otpErrorMessage" class="custom-alert text-center mt-2">
                            <span class="alert-icon">&#9888;</span>
                            <p>{{ otpErrorMessage }}</p>
                        </div>
                        <div class="d-flex justify-content-center mt-3">
                            <o-button type="button" class="otp-back-button" variant="secondary" @click="switchToLoginMode">
                                Back to Login
                            </o-button>
                        </div>
                    </o-form>
                    <div class="d-flex justify-content-center" id="login-container" v-if="!isOtpMode && !otpRequested && (isNativePlatform || merchant_id || (corporate_id && dashboard))">
                        <o-button v-if="$store.getters.authStatus === 'loading'" :disabled="true" :size="'block'">
                            Loading...
                        </o-button>
                        <div class="d-flex flex-column align-items-center">
                            <o-button :class="isNativePlatform ? 'native-login-button mb-3' : 'login-button mb-3'" v-if="$store.getters.authStatus !== 'loading'" :size="'block'" @click="submitLogin">
                                Login
                            </o-button>
                            <div class="text-center" v-if="!isOtpMode && !otpRequested && (isNativePlatform || merchant_id || (corporate_id && dashboard))">
                                <small class="text-policies" style="color: #808080;">
                                    By 
                                    <a style="color: #e74c3c; text-decoration: none;">logging in</a>
                                    and 
                                    <a style="color: #e74c3c; text-decoration: none;">signing up</a>
                                    , you agree to our
                                    <br>
                                    <a href="#" @click.prevent="openPrivacyPolicy" style="color: #e74c3c; text-decoration: none;">Privacy Policy</a> 
                                    and 
                                    <a href="#" @click.prevent="openTermsConditions" style="color: #e74c3c; text-decoration: none;">Terms & Conditions</a>
                                </small>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column align-items-center" id="google-login-container" v-if="!isOtpMode && !otpRequested && (isNativePlatform || merchant_id || (corporate_id && dashboard))">
                        <!-- Google Login Button - Native menggunakan component, Web menggunakan button biasa -->
                        <GoogleLoginButton 
                            v-if="isNativePlatform"
                            button-text="Log in with Google"
                            @login-success="handleGoogleLoginSuccess"
                            @login-error="handleGoogleLoginError"
                        />
                        <AppleLoginButton
                            v-if="isIosPlatform"
                            button-text="Sign in with Apple"
                            @login-success="handleAppleLoginSuccess"
                            @login-error="handleAppleLoginError"
                        />
                        <button v-if="!isNativePlatform && (merchant_id || (corporate_id && dashboard))" class="google-login-button" @click="loginWithGoogle">
                            <img src="https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/Google__G__logo.svg.png" class="google-icon">
                            <span class="google-login-text">Log in with Google</span>
                        </button>

                    </div>
                    <div class="divider-with-text" v-if="!isOtpMode && !otpRequested && (isNativePlatform || merchant_id || (corporate_id && dashboard))">
                        <span>or</span>
                    </div>

                    
                    <div class="d-flex justify-content-center" v-if="!isOtpMode && !otpRequested && (isNativePlatform || merchant_id || (corporate_id && dashboard))">
                        <medium style="color: #808080;">Don't have an account?&nbsp;</medium>
                        <a href="#" @click.prevent="goToSignUp" class="no-underline">
                            <medium>Sign Up</medium>
                        </a>
                    </div>

                    <div class="d-flex justify-content-center mb-2" id="login-container" v-if="!merchant_id && !corporate_id && !dashboard && !isOtpMode && !isNativePlatform">
                        <o-button v-if="$store.getters.authStatus === 'loading'" :disabled="true" :size="'block'">
                            Loading...
                        </o-button>
                        <div class="d-flex flex-column align-items-center">
                            <o-button class="login-button mb-3" v-if="$store.getters.authStatus !== 'loading'" :size="'block'" @click="submitLogin">
                                Login
                            </o-button>
                            <div class="text-center" v-if="!merchant_id && !corporate_id && !dashboard && !isOtpMode">
                                <small class="text-policies" style="color: #808080;">
                                    By 
                                    <a style="color: #e74c3c; text-decoration: none;">logging in</a>
                                    and 
                                    <a style="color: #e74c3c; text-decoration: none;">signing up</a>
                                    , you agree to our
                                    <br>
                                    <a href="#" @click.prevent="openPrivacyPolicy" style="color: #e74c3c; text-decoration: none;">Privacy Policy</a> 
                                    and 
                                    <a href="#" @click.prevent="openTermsConditions" style="color: #e74c3c; text-decoration: none;">Terms & Conditions</a>
                                </small>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Google Login removed for admin/staff login (non-merchant) -->
                    <!-- Admin/staff should only use email/password login -->
                    
                    <div class="simple-footer">
                        <small>
                            Copyright
                            <span>©</span>
                            PT. Omni Hotelier Internasional
                            <span>{{ currentYear }}</span>
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <o-modal 
        v-if="showPrivacyModal" 
        @close="closePrivacyModal"
        :modalClass="'show d-block policies-modal'"
        :bodyClass="'p-0'"
        :contentClass="'policies-modal-content'"
        :allow-html="false"
        :is-footer-visible="false"
        >
        <template #header>
            <h5 class="modal-title">Policies</h5>
        </template>
        <template #body>
            <div class="policies-container"
                style="height: 450px;
                        max-height: 450px;
                        min-height: 450px;
                        overflow: hidden;
                        display: flex;
                        flex-direction: column;
                        color: black;
                        word-wrap: break-word;
                        ">
                <!-- Tab Navigation -->
                <div class="policies-tabs">
                    <button 
                        class="tab-button" 
                        :class="{ active: activeTab === 'privacy' }"
                        @click="activeTab = 'privacy'">
                        Privacy Policy
                    </button>
                    <button 
                        class="tab-button" 
                        :class="{ active: activeTab === 'terms' }"
                        @click="activeTab = 'terms'">
                        Terms & Conditions
                    </button>
                </div>
                
                <!-- Tab Content -->
                <div class="tab-content" style="height: 450px; max-height: 450px; min-height: 450px; overflow-y: auto; padding: 1.5rem 1.5rem 2.5rem 1.5rem; flex: 1;">
                    <div v-if="activeTab === 'privacy'" class="policy-content">
                        <PublicPolicyDisplay type="privacy" />
                    </div>
                    
                    <div v-if="activeTab === 'terms'" class="policy-content">
                        <PublicPolicyDisplay type="terms" />
                    </div>
                </div>
            </div>
        </template>
        </o-modal>
    <TwoFactorVerify />
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { Capacitor } from '@capacitor/core';
import { OForm, OFormGroup, OInputText, OButton, OInputDigit } from '@/components/OmnihControl';
import api from '@/helpers/api';
import { OModal } from '@/components/OmnihControl';
import PublicPolicyDisplay from '@/components/PublicPolicyDisplay.vue';
import TwoFactorVerify from '@/components/two-factor/TwoFactorVerify.vue';
import GoogleLoginButton from '@/components/GoogleLoginButton.vue';
import AppleLoginButton from '@/components/AppleLoginButton.vue';
import storageService from '@/services/storageService';
import { pushNotificationHandler } from '@/mobile/plugins/pushNotification';
import { setSwipeBackEnabled } from '@/services/swipeBack';
import { resolveRefParameter, preserveRefForSso, clearRefContext } from '@/services/refParameter';

export default {
    name: 'Login',
    components: {
        OForm,
        OFormGroup,
        OInputText,
        OButton,
        OInputDigit,
        OModal,
        PublicPolicyDisplay,
        TwoFactorVerify,
        GoogleLoginButton,
        AppleLoginButton,
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const route = useRoute();

        const email = ref('');
        const password = ref('');
        const loading = ref(true);
        const validation = ref(false);
        const validateLevel = ref(false);
        const validationEntity = ref(false);
        const merchant_id = ref("");
        const validationMemberOnly = ref(false);
        const registerState = ref(false);
        const registerMessage = ref(false);
        const showPassword = ref(false);
        const branchLogo = ref('');
        const autoLoginData = ref(null);
        const corporate_id = ref("");
        const dashboard = ref(false);
        const otp = ref('');
        const otpRequested = ref(false);
        const otpErrorMessage = ref('');
        const redirectUrl = ref('');
        const showCountdown = ref(false);
        const showRefreshButton = ref(false);
        const countdownMinutes = ref(2);
        const countdownSeconds = ref(0);
        const countdownInterval = ref(null);
        const isOtpMode = ref(false);
        const isProcessing = ref(false);
        const loginBackground = ref('');
        const corporateLogo = ref('');
        const passwordErrorMessage = ref('');
        const activities = ref(false);
        const otpEmail = ref('');
        const showPrivacyModal = ref(false);
        const activeTab = ref('privacy');
        const referral_code = ref('');
        const refParam = ref('');
        watch(() => route.query.ref, (newRef) => {
            refParam.value = resolveRefParameter(newRef);
        });



        const _authCheckPromise = ref(null);
        const currentYear = new Date().getFullYear();
        const isNativePlatform = computed(() => Capacitor.isNativePlatform());
        const isIosPlatform = computed(() => Capacitor.getPlatform() === 'ios');


        const isLoggedIn = computed(() => store.getters['Auth/isLoggedIn']);


        const forgotPasswordLink = computed(() => {
            return window.location.search.includes('merchant_id')
                ? { name: 'ForgotPassword', query: { merchant_id: merchant_id.value } }
                : { name: 'ForgotPassword' };
        });
        const signUpLink = computed(() => {
            const params = corporate_id.value && dashboard.value 
                ? { merchant_id: corporate_id.value } 
                : { merchant_id: merchant_id.value };
            
            const query = {};
            if (referral_code.value) {
                query.referral = referral_code.value;
            }
            
            return { 
                name: 'MemberSignUp', 
                params: params,
                query: Object.keys(query).length > 0 ? query : undefined
            };
        });
        const formattedTime = computed(() => {
            const minutes = countdownMinutes.value;
            const seconds = countdownSeconds.value < 10 ? `0${countdownSeconds.value}` : countdownSeconds.value;
            return `${minutes}:${seconds}`;
        });
        const setCorporateLogo = computed(() => corporateLogo.value);
        const backgroundStyle = computed(() => ({
            backgroundImage: `url(${loginBackground.value})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        }));


        /**
         * Wrapper to handle loading states for asynchronous operations.
         * Prevents concurrent processing of the same request.
         * 
         * @param {Function} callback - The async function to execute
         * @returns {Promise} Result of the callback
         */
        const setLoadingState = async (callback) => {
            if (isProcessing.value) return Promise.reject(new Error('Request already in progress'));
            loading.value = true;
            isProcessing.value = true;
            try {
                const result = await callback();
                return result;
            } finally {
                loading.value = false;
                isProcessing.value = false;
            }
        };

        /**
         * Handles temporary web access by redirecting to a specific URL with session parameters.
         * Supports both direct window redirection and cross-window messaging (postMessage).
         * 
         * @param {Object} resp - API response containing redirect URL
         * @param {Object} resData - Session data to be transmitted
         */
        function handleWebTempAccess(resp, resData) {
            // Normalize redirectUrl: ensure it has a protocol
            let rawRedirectUrl = resp?.redirectUrl || resData?.url || '';
            if (rawRedirectUrl && !rawRedirectUrl.startsWith('http://') && !rawRedirectUrl.startsWith('https://')) {
                rawRedirectUrl = 'http://' + rawRedirectUrl;
            }

            if (!rawRedirectUrl) {
                console.error('[handleWebTempAccess] No valid redirectUrl found in response', resp);
                validation.value = true;
                passwordErrorMessage.value = 'Redirect URL not found. Please try again.';
                return;
            }

            if (window.opener === null) {
                try {
                    const redirectUrlObj = new URL(rawRedirectUrl);
                    redirectUrlObj.searchParams.append('username', resData.username);
                    redirectUrlObj.searchParams.append('token', resData.token);
                    redirectUrlObj.searchParams.append('tierId', resData.tierId);
                    if (resData.tier_name) redirectUrlObj.searchParams.append('tier_name', resData.tier_name);
                    if (resData.tier_icon) redirectUrlObj.searchParams.append('tier_icon', resData.tier_icon);
                    if (resData.voucher) redirectUrlObj.searchParams.append('voucher', resData.voucher);
                    if (resData.point) redirectUrlObj.searchParams.append('point', resData.point);
                    if (resData.media) redirectUrlObj.searchParams.append('media', resData.media);
                    window.location.href = redirectUrlObj.toString();
                } catch (e) {
                    console.error('[handleWebTempAccess] Invalid redirect URL:', rawRedirectUrl, e);
                    validation.value = true;
                    passwordErrorMessage.value = 'Invalid redirect URL. Please contact support.';
                }
            } else {
                window.opener.postMessage(resData, rawRedirectUrl);
                window.close();
            }
        }

        /**
         * Redirects the user based on their stored role and level.
         * Members are redirected to the client dashboard, while others stay or go to Home.
         */
        function handleRoleRedirect() {
            clearAutoLoginData();
            const storedRole = localStorage.getItem('role');
            const storedLevel = localStorage.getItem('level');
            if ((storedRole && storedRole !== 'member') && (storedLevel && storedLevel !== 'member')) {
                return;
            }
            // Check for intended URL from newsletter deep link (or other client routes)
            const redirectPath = localStorage.getItem('redirect_after_login');
            localStorage.removeItem('redirect_after_login');
            if (redirectPath && redirectPath.startsWith('/client/')) {
                router.replace(redirectPath);
                return;
            }
            router.replace({ name: 'client_dashboard' });
        }

        /**
         * Executes automatic login using stored credentials or session data.
         * Handles both standard and temporary web access login flows.
         */
        const autoLogin = async () => {
            if (!autoLoginData.value) {
                loading.value = false;
                return;
            }
            return setLoadingState(async () => {
                try {
                    const loginData = {
                        email: autoLoginData.value.email,
                        password: autoLoginData.value.password,
                        token: autoLoginData.value.token,
                        merchant_id: autoLoginData.value.merchant_id,
                        type: autoLoginData.value.type,
                        corporate_id: autoLoginData.value.corporate_id,
                        dashboard: autoLoginData.value.dashboard,
                        ref: autoLoginData.value.ref || refParam.value
                    };
                    const res = await store.dispatch('Auth/login', loginData);
                    localStorage.removeItem('autoLoginData');
                    if (res?.type === "web_temp_access" && res?.url !== null) {
                        const url = `${res.url}?member_token=${res.token}`;
                        const resData = {};
                        for (const key in res) {
                            if (Object.prototype.hasOwnProperty.call(res, key) && key !== 'url') {
                                resData[key] = res[key];
                                localStorage.setItem(key, JSON.stringify(res[key]));
                            }
                        }
                        let resp = null;
                        let response = null;
                        try {
                            response = await fetch(url);
                            resp = await response.json();
                        } catch (error) {
                            validation.value = true;
                            passwordErrorMessage.value = "Auto-login failed. Please try again manually.";
                            return;
                        }
                        if (!response || !response.ok) {
                            await handleFetchError(response, resp, logout);
                            return;
                        }
                        handleWebTempAccess(resp, resData);
                        return;
                    }
                    if (res?.type === "web_temp_access" && res?.url === null) {
                        validation.value = true;
                        return;
                    }
                    if (res.role === "member" || res.level === "member") {
                        handleRoleRedirect();
                        clearRefContext();
                        return;
                    }
                    clearAutoLoginData();
                    router.replace({ name: 'Home' });
                    clearRefContext();
                } catch (err) {
                    if (err.response?.status === 429) {
                        validation.value = true;
                        passwordErrorMessage.value = "Rate limit exceeded. Please try again later.";
                    } else if (err.response?.data?.message === "AUTH.LOGIN.CORPORATE_ID_MISMATCH") {
                        validation.value = true;
                        passwordErrorMessage.value = "Please log in with account based merchant.";
                    } else {
                        validation.value = true;
                        passwordErrorMessage.value = "Auto-login failed. Please try again manually.";
                    }
                }
            });
        };

        /**
         * Switches the interface to OTP login mode.
         */
        const switchToOtpMode = () => {
            isOtpMode.value = true;
            otpRequested.value = false;
            otpEmail.value = '';
            otp.value = '';
            otpErrorMessage.value = '';
        };

        /**
         * Switches the interface back to standard email/password login mode.
         */
        const switchToLoginMode = () => {
            isOtpMode.value = false;
            email.value = '';
            password.value = '';
            otpRequested.value = false;
            otpEmail.value = '';
            otp.value = '';
            showCountdown.value = false;
            clearInterval(countdownInterval.value);
        };

        /**
         * Starts a 2-minute countdown for OTP resend functionality.
         */
        const startCountdown = () => {
            showCountdown.value = true;
            showRefreshButton.value = false;
            countdownMinutes.value = 2;
            countdownSeconds.value = 0;
            clearInterval(countdownInterval.value);
            countdownInterval.value = setInterval(() => {
                if (countdownSeconds.value > 0) {
                    countdownSeconds.value--;
                    return;
                }
                if (countdownMinutes.value > 0) {
                    countdownMinutes.value--;
                    countdownSeconds.value = 59;
                    return;
                }
                clearInterval(countdownInterval.value);
                showCountdown.value = false;
                showRefreshButton.value = true;
            }, 1000);
        };
        /**
         * Parses error responses from the login API and provides user-friendly error messages.
         * 
         * @param {Object} err - Error object from the API request
         */
        function handleLoginErrorResponse(err) {
            if (!err.response) {
                validation.value = true;
                passwordErrorMessage.value = "Network error. Please try again later.";
                return;
            }
            const msg = err.response.data.message;
            const error = err.response.data.error;
            const errorMap = {
                "AUTH.LOGIN.INVALID.AUTH.FAIL.LEVEL": () => { validateLevel.value = true; },
                "AUTH.LOGIN.VALIDATION_ERROR": () => {
                    const parsedError = typeof error === "string" ? JSON.parse(error) : error;

                    if (error && error.includes('at least 6 characters')) {
                        if(parsedError.email && parsedError.password) {
                            validation.value = true;
                            passwordErrorMessage.value = `${parsedError.email[0]} and ${parsedError.password[0]}`;
                        } else {
                            validation.value = true;
                            passwordErrorMessage.value = parsedError.password[0];
                        }
                    }else if (error && error.includes('field is required')) {
                        if (parsedError.email && parsedError.password) {
                            validation.value = true; 
                            passwordErrorMessage.value = `${parsedError.email[0]} and ${parsedError.password[0]}`;
                        } 
                        else if (parsedError.email) {
                            validation.value = true;
                            passwordErrorMessage.value = parsedError.email[0];
                        } 
                        else if (parsedError.password) {
                            validation.value = true;
                            passwordErrorMessage.value = parsedError.password[0];
                        }
                    } else {
                        validation.value = true;
                        passwordErrorMessage.value = parsedError.email[0];
                    }
                },
                "AUTH.LOGIN.FAILED.UNKNOWN.ENTITY": () => { validation.value = false; validationEntity.value = true; },
                "AUTH.LOGIN.FAILED.MEMBER.NOT.YET.ACCEPTED": () => { validation.value = true; passwordErrorMessage.value = "Your account is still pending approval. Please wait for merchant verification."; },
                "AUTH.LOGIN.FAILED.MEMBER.LOGIN.WITH.SOCIALITE": () => { validation.value = true; passwordErrorMessage.value = "Please log in using your social media account."; },
                "AUTH.LOGIN.INVALID_EMAIL_PASSWORD.ERROR": () => { validation.value = true; passwordErrorMessage.value = "Invalid email or password account."; },
                "AUTH.LOGIN.CORPORATE_ID_MISMATCH": () => { validation.value = true; passwordErrorMessage.value = "Member ID does not match in at merchant"; }
            };
            if (errorMap[msg]) {
                errorMap[msg]();
            } else if (msg && msg.includes("No query results for model")) {
                validation.value = true;
                passwordErrorMessage.value = "Not Found";
            } else if (typeof msg === 'string' && msg === msg.toUpperCase()) {
                validation.value = true;
                passwordErrorMessage.value = error;
            } else {
                validation.value = true;
                passwordErrorMessage.value = msg;
            }
        }

        /**
         * Handles fetch errors specifically for external session initialization.
         * 
         * @param {Response} response - Fetch response object
         * @param {Object} resp - Parsed JSON response
         * @param {Function} logoutFn - Callback for logout upon critical errors
         */
        async function handleFetchError(response, resp, logoutFn) {
            const errorMessage = resp?.error || "An unexpected error occurred.";
            if (errorMessage === "Please contact the property to check the URL.") {
                await logoutFn(errorMessage);
            }
            validation.value = true;
            passwordErrorMessage.value = errorMessage;
        }

        /**
         * Processes the success response from OTP validation.
         * Handles redirection and temporary web access protocols.
         * 
         * @param {Object} res - Success response data
         * @returns {Promise<boolean>}
         */
        async function processOtpResponse(res) {
            if (res?.type === "web_temp_access") {
                if (res?.url === null) {
                    throw new Error("Invalid reference parameter for Booking Engine integration.");
                }
                let url = `${res.url}?member_token=${res.token}`;
                if (activities.value) {
                    url = `${res.url}?member_token=${res.token}&activities=true`;
                }
                const resData = {};
                for (const key in res) {
                    if (Object.prototype.hasOwnProperty.call(res, key) && key !== 'url') {
                        resData[key] = res[key];
                        localStorage.setItem(key, JSON.stringify(res[key]));
                    }
                }
                let resp = null;
                let response = null;
                try {
                    response = await fetch(url);
                    resp = await response.json();
                } catch (error) {
                    validation.value = true;
                    passwordErrorMessage.value = "Auto-login failed. Please try again manually.";
                    return true;
                }
                if (!response || !response.ok) {
                    await handleFetchError(response, resp, logout);
                    return true;
                }
                handleWebTempAccess(resp, resData);
                return true;
            }
            if (res.level == "member") {
                handleRoleRedirect();
                // Clean up SSO ref parameter from localStorage after successful OTP login
                clearRefContext();
                return true;
            }
            clearAutoLoginData();
            router.replace({ name: 'Home' });
            // Clean up SSO ref parameter from localStorage after successful OTP login
            clearRefContext();
            return true;
        }

        /**
         * Requests a new One-Time Password (OTP) to be sent to the user's email.
         */
        const requestOtp = async () => {
            const email = otpEmail.value.trim();
            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                otpErrorMessage.value = 'Please enter a valid email to receive OTP.';
                return;
            }
            otpEmail.value = email;
            return setLoadingState(async () => {
                const data = {
                    email: otpEmail.value,
                    otp_login: "login",
                    ref: refParam.value || undefined,
                };
                const isExternalAccess = Boolean(
                    refParam.value
                    && (merchant_id.value || (corporate_id.value && dashboard.value))
                );
                if (isExternalAccess) {
                    data.merchant_id = merchant_id.value || "";
                    data.corporate_id = corporate_id.value || "";
                    data.dashboard = dashboard.value || "";
                    data.type = 'web_temp_access';
                }
                try {
                    await store.dispatch('Member/request_otp', { data });
                    otpRequested.value = true;
                    otpErrorMessage.value = '';
                    startCountdown();
                } catch (error) {
                    if (error.response && error.response.data) {
                        const serverResponse = error.response.data;
                        otpErrorMessage.value = serverResponse.error || serverResponse.message || 'Failed to send OTP. Please try again.';
                    } else if (error.message) {
                        otpErrorMessage.value = error.message;
                    } else {
                        otpErrorMessage.value = 'Failed to send OTP. Please try again.';
                    }
                }
            });
        };

        const handleOtpFormSubmit = () => {
            if (otpRequested.value) {
                return submitOtp();
            }
            return requestOtp();
        };

        /**
         * Triggers a re-request of the OTP and resets the countdown.
         */
        const resendOTP = async () => {
            otpErrorMessage.value = '';
            await requestOtp();
        };

        const otpErrorMap = {
            "AUTH.LOGIN.INVALID.AUTH.FAIL.LEVEL": "Invalid level. Please log in with a valid member account.",
            "AUTH.LOGIN.CORPORATE_ID_MISMATCH": "Member ID does not match in at Corporate"
        };
        /**
         * Submits the user-entered OTP for verification.
         */
        const submitOtp = async () => {
            if (!otp.value) {
                otpErrorMessage.value = 'Please enter the OTP code.';
                return;
            }
            otpErrorMessage.value = '';
            return setLoadingState(async () => {
                try {
                    await store.dispatch('Member/submit_otp', {
                        email: otpEmail.value,
                        otp: otp.value,
                        otp_login: "login",
                    });
                    const isExternalAccess = Boolean(
                        refParam.value
                        && (merchant_id.value || (corporate_id.value && dashboard.value))
                    );
                    const data = {
                        email: otpEmail.value,
                        otp_login: "login",
                        ref: refParam.value || undefined,
                    };
                    if (isExternalAccess) {
                        data.merchant_id = merchant_id.value || "";
                        data.corporate_id = corporate_id.value || "";
                        data.dashboard = dashboard.value || "";
                    }
                    const res = await store.dispatch('Auth/checkLogin', data);
                    await processOtpResponse(res);
                } catch (err) {
                    const msg = err.response?.data?.message;
                    otpErrorMessage.value = otpErrorMap[msg] || "Failed to verify OTP.";
                }
            });
        };
        /**
         * Performs a standard email/password login.
         * Handles 2FA, temporary web access, and role-based redirection.
         */
        const login = async () => {
            return setLoadingState(async () => {
                validation.value = false;
                validateLevel.value = false;
                validationEntity.value = false;
                validationMemberOnly.value = false;
                passwordErrorMessage.value = '';

                // Native platform: gunakan login biasa, restrict non-member di backend via platform flag
                if (isNativePlatform.value) {
                    const data = {
                        email: email.value,
                        password: password.value,
                        otp_login: "login",
                        platform: 'native',
                        ref: refParam.value || undefined,
                    };
                    
                    // Hanya tambahkan corporate_id dan dashboard jika ada
                    if (corporate_id.value) {
                        data.corporate_id = corporate_id.value;
                    }
                    if (dashboard.value) {
                        data.dashboard = dashboard.value;
                    }
                    
                    try {
                        const res = await store.dispatch('Auth/login', data);
                        
                        if (res?.requires_2fa) {
                            loading.value = false;
                            return;
                        }
                        if (res?.type === "web_temp_access" && res?.url !== null) {
                            let url = `${res.url}?member_token=${res.token}`;
                            if (activities.value) {
                                url = `${res.url}?member_token=${res.token}&activities=true`;
                            }
                            redirectUrl.value = res.url;
                            const resData = {};
                            for (const key in res) {
                                if (Object.prototype.hasOwnProperty.call(res, key) && key !== 'url') {
                                    resData[key] = res[key];
                                    localStorage.setItem(key, JSON.stringify(res[key]));
                                }
                            }
                            let resp = null;
                            let response = null;
                            try {
                                response = await fetch(url);
                                resp = await response.json();
                            } catch (error) {
                                const retryData = {
                                    email: email.value,
                                    password: password.value,
                                    token: res.token,
                                    type: res.type,
                                    ref: refParam.value
                                };
                                if (merchant_id.value) retryData.merchant_id = merchant_id.value;
                                if (corporate_id.value) retryData.corporate_id = corporate_id.value;
                                if (dashboard.value) retryData.dashboard = dashboard.value;
                                
                                localStorage.setItem('autoLoginData', JSON.stringify(retryData));
                                validation.value = true;
                                passwordErrorMessage.value = "Auto-login failed. Please try again manually.";
                                return;
                            }
                            if (!response || !response.ok) {
                                await handleFetchError(response, resp, logout);
                                return;
                            }
                            handleWebTempAccess(resp, resData);
                            clearRefContext();
                            return;
                        }
                        if (res.level == "member") {
                            handleRoleRedirect();
                            clearRefContext();
                            return;
                        }
                        router.replace({ name: 'Home' });
                        clearRefContext();
                    } catch (err) {
                        handleLoginErrorResponse(err);
                    }
                    return;
                }

                // Web platform: flow yang sudah ada (tidak diubah)
                const data = {
                    email: email.value,
                    password: password.value,
                    otp_login: "login",
                    ref: refParam.value || undefined,
                };
                
                // Hanya tambahkan merchant_id jika ada (untuk member login)
                if (merchant_id.value) {
                    data.merchant_id = merchant_id.value;
                }
                
                // Hanya tambahkan corporate_id dan dashboard jika ada
                if (corporate_id.value) {
                    data.corporate_id = corporate_id.value;
                }
                if (dashboard.value) {
                    data.dashboard = dashboard.value;
                }
                try {
                    const res = await store.dispatch('Auth/login', data);
                    
                    if (res?.requires_2fa) {
                        loading.value = false;
                        return;
                    }
                    if (res?.type === "web_temp_access" && res?.url !== null) {
                        let url = `${res.url}?member_token=${res.token}`;
                        if (activities.value) {
                            url = `${res.url}?member_token=${res.token}&activities=true`;
                        }
                        redirectUrl.value = res.url;
                        const resData = {};
                        for (const key in res) {
                            if (Object.prototype.hasOwnProperty.call(res, key) && key !== 'url') {
                                resData[key] = res[key];
                                localStorage.setItem(key, JSON.stringify(res[key]));
                            }
                        }
                        let resp = null;
                        let response = null;
                        try {
                            response = await fetch(url);
                            resp = await response.json();
                        } catch (error) {
                            const retryData = {
                                email: email.value,
                                password: password.value,
                                token: res.token,
                                merchant_id: merchant_id.value,
                                type: res.type,
                                corporate_id: corporate_id.value,
                                dashboard: dashboard.value,
                                ref: refParam.value
                            };
                            localStorage.setItem('autoLoginData', JSON.stringify(retryData));
                            validation.value = true;
                            passwordErrorMessage.value = "Auto-login failed. Please try again manually.";
                            return;
                        }
                        if (!response || !response.ok) {
                            await handleFetchError(response, resp, logout);
                            return;
                        }
                        handleWebTempAccess(resp, resData);
                    } else if (res.level == "member") {
                        handleRoleRedirect();
                    } else {
                        router.replace({ name: 'Home' });
                    }
                    clearRefContext();
                } catch (err) {
                    handleLoginErrorResponse(err);
                }
            });
        };
        const submitLogin = () => {
            login();
        };
        /**
         * Logs the user out, clears session data from storage, and optionally displays an error.
         * 
         * @param {string|null} errorMessage - Optional error message to display after logout
         */
        const logout = async (errorMessage = null) => {
            try {
                loading.value = true;
                let token = localStorage.getItem('token');
                if (token) {
                    token = token.replace(/^"(.*)"$/, '$1');
                    localStorage.removeItem('token');
                    localStorage.setItem('token', token);
                    let token2 = localStorage.getItem('token');
                    await store.dispatch('Auth/logoutError', token2);
                }
                localStorage.clear();
                if (errorMessage) {
                    validation.value = true;
                    passwordErrorMessage.value = errorMessage;
                }
            } catch (err) {
                loading.value = false;
            }
        };
        /**
         * Provides a visual delay for session check on initial load.
         */
        const checkSessionOnLoad = async () => {
            loading.value = true;
            setTimeout(() => {
                loading.value = false;
            }, 0);
        };
        /**
         * Initiates the Google Single Sign-On (SSO) flow.
         * Handles referral codes and environment-specific parameters.
         */
        const loginWithGoogle = () => {
            const merchantId = route.query.merchant_id || null;
            const corporateId = route.query.corporate_id || null;
            const dashboardVal = route.query.dashboard || null;
            
            // Store ref parameter in localStorage before SSO redirect
            preserveRefForSso(refParam.value);
            
            // Get referral code from localStorage
            const referralCode = localStorage.getItem('campaign_referral_code') || referral_code.value || null;

            // Prepare state parameter with referral code
            let stateData = {};
            if (referralCode) {
                stateData.referral_code = referralCode;
            }

            // Encode state as base64
            const stateParam = btoa(JSON.stringify(stateData));

            if (merchantId) {
                store.dispatch('Auth/googleLogin', { merchant_id: merchantId, state: stateParam });
            } else if (corporateId && dashboardVal) {
                store.dispatch('Auth/googleLogin', { corporate_id: corporateId, dashboard: dashboardVal, state: stateParam });
            } else {
                store.dispatch('Auth/googleLogin', { state: stateParam });
            }
        };

        // New Google Login handlers using GoogleLoginButton component
        /**
         * Success handler for Google Login component.
         * Persists user data, synchronizes native storage, and handles platform-specific redirection.
         * 
         * @param {Object} authData - Authentication data from Google
         */
        const handleGoogleLoginSuccess = async (authData) => {
            try {
                loading.value = true;
                
                // Extract data from response
                const userData = authData.data?.user || authData.user;
                const token = authData.data?.token || authData.token;
                const tenantDomain = authData.data?.tenant_domain || authData.tenant_domain;
                
                if (!token) {
                    throw new Error('No token received from backend');
                }
                
                if (!userData) {
                    throw new Error('No user data received from backend');
                }
                
                // Save to localStorage
                try {
                    localStorage.setItem('token', token);

                    // Split nama jika first_name/last_name kosong dari OAuth
                    if (Capacitor.isNativePlatform()) {
                        if (!userData.first_name && !userData.last_name && userData.name) {
                            const parts = userData.name.trim().split(' ');
                            userData.first_name = parts[0] || '';
                            userData.last_name = parts.slice(1).join(' ') || '';
                        }
                        if (!userData.title) userData.title = '';
                    }

                    localStorage.setItem('user', JSON.stringify(userData));
                    
                    // Set level for route guard
                    if (userData.member) {
                        localStorage.setItem('level', 'member');
                    } else {
                        // For admin/staff, set as 'admin' if not member
                        localStorage.setItem('level', 'admin');
                    }
                    
                    // Ensure tenant domain is set for API calls
                    if (tenantDomain) {
                        localStorage.setItem('tenant_domain', tenantDomain);
                    } else {
                        const storedTenantDomain = localStorage.getItem('tenant_domain');
                        if (!storedTenantDomain) {
                            const currentTenant = require('@/config/tenant').currentTenant;
                            if (currentTenant && currentTenant.domain) {
                                localStorage.setItem('tenant_domain', currentTenant.domain);
                            }
                        }
                    }
                    
                    // Sync to native storage for auto-login in mobile environments
                    if (Capacitor.isNativePlatform()) {
                        try {
                            await storageService.syncToNative();
                        } catch (syncError) {
                            // Non-blocking error
                        }
                    }
                } catch (storageError) {
                    // Fail silently for storage
                }

                // Clean up referral parameters
                try {
                    clearRefContext();
                    localStorage.removeItem('campaign_referral_code');
                } catch (e) {
                    // Ignore
                }

                // Update Vuex store with new auth status
                try {
                    store.commit('Auth/set_login_provider', 'google');
                    store.commit('Auth/auth_success', {
                        token: token,
                        user: userData
                    });
                    
                    // Refresh full user data from server
                    await store.dispatch('Auth/auth_check');
                } catch (storeError) {
                    // Non-blocking error
                }

                // Register device token ke backend setelah auth token siap
                if (Capacitor.isNativePlatform()) {
                    try {
                        await pushNotificationHandler.registerDevice();
                    } catch (pushError) {
                        console.error('[Google Login] Push notification registration failed:', pushError);
                        // Non-blocking — jangan hentikan alur login
                    }
                }

                // Gunakan router (bukan window.location.href) saat login agar JS context tidak reload & listener push notification tidak terputus
                const routeName = userData.member ? 'client_dashboard' : 'Home';
                router.replace({ name: routeName }).catch(() => {
                    // Fallback hanya jika router.push gagal
                    const redirectUrlPath = userData.member ? '/client/dashboard' : '/';
                    window.location.href = redirectUrlPath;
                });
                
            } catch (error) {
                validation.value = true;
                passwordErrorMessage.value = error.message || 'Failed to complete Google login. Please try again.';
                loading.value = false;
            }
        };

        /**
         * Error handler for Google Login component.
         * 
         * @param {Error} error - The error encountered during login
         */
        const googleLoginErrorMessages = {
            'AUTH.LOGIN.FAILED.MEMBER.NOT.YET.ACCEPTED': 'Your account is still pending approval. Please wait for merchant verification.',
            'AUTH.LOGIN.FAILED.MEMBER.LOGIN.WITH.SOCIALITE': 'This account was registered via email. Please log in using your email and password.',
            'AUTH.GOOGLE.EMAIL_EXISTS_APPLE': 'This email is already registered with Apple Sign-In. Please sign in using the Sign in with Apple button.',
            'AUTH.GOOGLE.ACCOUNT_MISMATCH': 'This email is already associated with a different Google account.',
        };

        const handleGoogleLoginError = (error) => {
            const code = error.code || '';
            const msg = error.message || '';
            validation.value = true;
            passwordErrorMessage.value = googleLoginErrorMessages[code] || googleLoginErrorMessages[msg] || error.message || 'Google login failed. Please try again.';
        };

        const handleAppleLoginSuccess = async (authData) => {
            try {
                loading.value = true;
                
                const userData = authData.data?.user || authData.user;
                const token = authData.data?.token || authData.token;
                const tenantDomain = authData.data?.tenant_domain || authData.tenant_domain;
                
                if (!token) throw new Error('No token received from backend for Apple login');
                if (!userData) throw new Error('No user data received from backend for Apple login');
                
                try {
                    localStorage.setItem('token', token);

                    if (Capacitor.isNativePlatform()) {
                        if (!userData.first_name && !userData.last_name && userData.name) {
                            const parts = userData.name.trim().split(' ');
                            userData.first_name = parts[0] || '';
                            userData.last_name = parts.slice(1).join(' ') || '';
                        }
                        if (!userData.title) userData.title = '';
                    }

                    localStorage.setItem('user', JSON.stringify(userData));
                    
                    if (userData.member) {
                        localStorage.setItem('level', 'member');
                    } else {
                        localStorage.setItem('level', 'admin');
                    }
                    
                    if (tenantDomain) {
                        localStorage.setItem('tenant_domain', tenantDomain);
                    }
                    
                    if (Capacitor.isNativePlatform()) {
                        try {
                            await storageService.syncToNative();
                        } catch (syncError) {
                            // Non-blocking
                        }
                    }
                } catch (storageError) {
                    // Fail silently
                }

                try {
                    clearRefContext();
                    localStorage.removeItem('campaign_referral_code');
                } catch (e) {
                    // Ignore error
                }

                try {
                    store.commit('Auth/set_login_provider', 'apple');
                    store.commit('Auth/auth_success', { token, user: userData });
                    await store.dispatch('Auth/auth_check');
                } catch (storeError) {
                    // Ignore error
                }

                if (Capacitor.isNativePlatform()) {
                    try {
                        await pushNotificationHandler.registerDevice();
                    } catch (pushError) {
                        console.error('[Apple Login] Push notification registration failed:', pushError);
                    }
                }

                const routeName = userData.member ? 'client_dashboard' : 'Home';
                router.replace({ name: routeName }).catch(() => {
                    const redirectUrlPath = userData.member ? '/client/dashboard' : '/';
                    window.location.href = redirectUrlPath;
                });
                
            } catch (error) {
                validation.value = true;
                passwordErrorMessage.value = error.message || 'Failed to complete Apple login. Please try again.';
                loading.value = false;
            }
        };

        const appleLoginErrorMessages = {
            'AUTH.LOGIN.FAILED.MEMBER.NOT.YET.ACCEPTED': 'Your account is still pending approval. Please wait for merchant verification.',
            'AUTH.APPLE.EMAIL_EXISTS_STANDARD': 'This email is already registered with Email & Password. Please sign in using the standard login form.',
            'AUTH.APPLE.EMAIL_EXISTS_GOOGLE': 'This email is already registered with Google Sign-In. Please sign in using the Sign in with Google button.',
            'AUTH.APPLE.ACCOUNT_MISMATCH': 'This email is already linked to a different Apple account.',
            'CANCELED': 'Apple Sign-In failed: Cancelled by user.',
        };

        const handleAppleLoginError = (error) => {
            const code = error.code || '';
            const msg = error.message || '';
            const lower = (code + ' ' + msg).toLowerCase();

            if (lower.includes('cancel') || lower.includes('1001') || lower.includes('1000')) {
                passwordErrorMessage.value = 'Apple Sign-In failed: Cancelled by user.';
            } else {
                passwordErrorMessage.value = appleLoginErrorMessages[code] || error.message || 'Apple Sign-In failed. Please try again.';
            }
            validation.value = true;
        };

        /**
         * Initiates the Facebook login flow.
         */
        const loginWithFacebook = () => {
            const merchantId = route.query.merchant_id || null;
            store.dispatch('Auth/facebookLogin', merchantId);
        };

        /**
         * Initiates the LinkedIn login flow.
         */
        const loginWithLinkedin = () => {
            const merchantId = route.query.merchant_id || null;
            store.dispatch('Auth/linkedinLogin', merchantId);
        };
        /**
         * Checks the current authentication status and redirects to dashboard if valid.
         * 
         * @returns {Promise} Result of the authentication check
         */
        const performAuthCheck = async () => {
            if (_authCheckPromise.value) return _authCheckPromise.value;
            _authCheckPromise.value = store.dispatch('Auth/auth_check')
                .then((resp) => {
                    localStorage.setItem('id', resp.data.id);
                    if (resp.data.member) {
                        localStorage.setItem('level', 'member');
                    }
                    router.replace({ name: "client_dashboard" });
                    return resp;
                })
                .catch(() => {
                    router.replace({ name: "Login" });
                })
                .finally(() => {
                    setTimeout(() => {
                        _authCheckPromise.value = null;
                    }, 5000);
                });
            return _authCheckPromise.value;
        };
        /**
         * Clears temporary auto-login credential data from storage.
         */
        const clearAutoLoginData = () => {
            localStorage.removeItem('autoLoginData');
            localStorage.removeItem('autoLoginRetryCount');
        };
        /**
         * Validates if an image exists at the given URL.
         * 
         * @param {string} url - URL of the image to check
         * @returns {Promise<boolean>} True if the image loads successfully
         */
        const checkImage = (url) => {
            return new Promise((resolve) => {
                const img = new window.Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = url;
            });
        };
        /**
         * Event handler for storage changes across tabs.
         * Primarily used for updating theme/background settings dynamically.
         */
        const handleStorageChange = (event) => {
            if (event.key === 'loginBackground') {
                loginBackground.value = event.newValue || '/img/temporary-login.png';
            }
        };

        const handlePageShow = (event) => {
            if (event.persisted) {
                window.location.reload();
            }
        };

        /**
         * Primary lifecycle hook.
         * Initializes application state, restores sessions, and handles URL-derived parameters.
         */
        onMounted(async () => {
            window.addEventListener('storage', handleStorageChange);
            window.addEventListener('pageshow', handlePageShow);
            // Disable swipe-back on login page — no valid page to go back to
            await setSwipeBackEnabled(false);
            loading.value = true;
            
            // Restore session
            await store.dispatch('Auth/restoreSession');

            const urlParams = new URLSearchParams(window.location.search);
            activities.value = urlParams.get('activities') === 'true' || route.query.activities === 'true' || route.query.activities === true;
            refParam.value = resolveRefParameter(route.query.ref);
            const emailParam = urlParams.get('email');
            const passwordParam = urlParams.get('member_token');
            const token = urlParams.get('token');
            const merchantId = urlParams.get('merchant_id') || route.query.merchant_id;
            const type = urlParams.get('type');
            const errorMessage = urlParams.get('error_message');
            const corporateId = urlParams.get('corporate_id') || route.query.corporate_id;
            const dashboardVal = urlParams.get('dashboard') === 'true' || route.query.dashboard === 'true' || route.query.dashboard === true;
            const registerStateFromUrl = urlParams.get('registerState');
            corporate_id.value = corporateId;
            dashboard.value = dashboardVal;
            merchant_id.value = merchantId;

            // If already logged in, check for external integration (web_temp_access) or redirect to dashboard
            if (store.getters['Auth/isLoggedIn']) {
                const level = localStorage.getItem('level');

                if (!isNativePlatform.value && (merchantId || (corporateId && dashboardVal))) {
                    const currUser = store.state.Auth.currUser;
                    const userEmail = currUser?.email || currUser?.realEmail || localStorage.getItem('email') || '';

                    if (userEmail) {
                        const data = {
                            email: userEmail,
                            merchant_id: merchantId || "",
                            corporate_id: corporateId || "",
                            dashboard: dashboardVal || "",
                            otp_login: "login",
                            type: "web_temp_access",
                            ref: refParam.value || undefined
                        };
                        try {
                            const res = await store.dispatch('Auth/checkLogin', data);
                            const processed = await processOtpResponse(res);
                            if (processed) return;
                        } catch (err) {
                            console.error("Auto login to external integration failed", err);
                            handleLoginErrorResponse(err);
                            await logout(passwordErrorMessage.value || "Your current session is invalid for this merchant. Please log in again.");
                            return;
                        }
                    }
                }

                if (level === 'member') {
                    router.replace({ name: 'client_dashboard' });
                } else {
                    router.replace({ name: 'Home' });
                }
                return;
            }

            // Check new_auth_module feature flag for native (when not logged in)
            if (Capacitor.isNativePlatform()) {
                try {
                    const flagResponse = await api.request('get', '/api/public/auth-module-status');
                    const isNewAuthEnabled = flagResponse.data?.data?.enabled;
                    if (isNewAuthEnabled) {
                        router.replace({ name: 'MemberLogin' });
                        return;
                    }
                } catch (flagError) {
                    console.warn('[Login] Feature flag check failed, using legacy login:', flagError.message);
                }
            }
            
            try {

                const referralFromUrl = urlParams.get('referral') || route.query.referral;
                if (referralFromUrl) {
                    referral_code.value = referralFromUrl;
                    localStorage.setItem('campaign_referral_code', referralFromUrl);
                } else {
                    const storedReferral = localStorage.getItem('campaign_referral_code');
                    if (storedReferral) {
                        referral_code.value = storedReferral;
                    }
                }

                if (emailParam && passwordParam && token && type === 'web_temp_access') {
                    const loginData = { email: emailParam, password: passwordParam, token, merchant_id: merchantId, type, corporate_id: corporateId, dashboard: dashboardVal, ref: refParam.value };
                    localStorage.setItem('autoLoginData', JSON.stringify(loginData));
                }
                await new Promise(resolve => setTimeout(resolve, 300));
                    if (isOtpMode.value) {
                    startCountdown();
                }
                if (errorMessage) {
                    validation.value = true;
                if (errorMessage.includes('Email+is+already')) {
                    passwordErrorMessage.value = 'Email is already registered. Please check your Google, Facebook, or LinkedIn account.';
                } else if (errorMessage.includes('Login+canceled')) {
                    passwordErrorMessage.value = 'Login with account canceled.';
                } else if (errorMessage.includes('No+user+found+with+this+google+login.')) {
                    passwordErrorMessage.value = 'No user found with this google login.';
                    urlParams.delete('error_message');
                    window.history.replaceState({}, '', window.location.pathname);
                    return;
                }
                passwordErrorMessage.value = decodeURIComponent(errorMessage.replace(/\+/g, ' '));
                handleLoginError(passwordErrorMessage.value);
                urlParams.delete('error_message');
                window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
                }
                if (merchantId) {
                store.dispatch('Merchant/read_branch_logo', merchantId)
                    .then((resp) => {
                    branchLogo.value = resp;
                    })
                    .catch(() => {
                        // Suppressed error for production
                    });
                } else if (corporateId) {
                store.dispatch('Corporate/read_corp_logo', corporateId)
                    .then((resp) => {
                        branchLogo.value = resp;
                    })
                    .catch(() => {
                        // Suppressed error for production
                    });
                }
                const registerStateBefore = router.options?.history?.state?.register;
                registerState.value = registerStateBefore !== undefined;
                registerMessage.value = registerStateBefore && registerStateBefore != 0;
                const savedAutoLoginData = localStorage.getItem('autoLoginData');
                if (registerMessage.value === false) {
                    checkSessionOnLoad();
                } else if (emailParam && token && merchantId && passwordParam && type === 'web_temp_access') {
                    autoLoginData.value = { email: emailParam, password: passwordParam, token, merchant_id: merchantId, type };
                    await autoLogin();
                } else if (emailParam && token && passwordParam && dashboardVal && corporateId && !type && !merchantId) {
                    autoLoginData.value = { email: emailParam, password: passwordParam, token, corporate_id: corporateId, dashboard: dashboardVal };
                    await autoLogin();
                } else if (emailParam && token && passwordParam && !type && !merchantId) {
                    email.value = emailParam;
                    password.value = passwordParam;
                    await login();
                } else if (!emailParam && !passwordParam && merchantId && !type && !token) {
                    checkSessionOnLoad();
                } else if (!merchantId && localStorage.getItem('token')) {
                    const tokenType = localStorage.getItem('type');
                    if (tokenType === 'web_temp_access' || tokenType?.includes('web_temp_access')) {
                        await performAuthCheck();
                    }
                } else if (savedAutoLoginData) {
                    autoLoginData.value = JSON.parse(savedAutoLoginData);
                    await autoLogin();
                } else {
                    checkSessionOnLoad();
                }
                if (localStorage.getItem('token') && localStorage.getItem('token').includes('"')) {
                    for (let i = 0; i < localStorage.length; i++) {
                        const key = localStorage.key(i);
                        let value = localStorage.getItem(key);
                        if (value && value.includes('"')) {
                            try {
                                const parsed = JSON.parse(value);
                                localStorage.setItem(key, typeof parsed === 'string' ? parsed : JSON.stringify(parsed));
                            } catch (e) {
                                const newValue = value.replace(/"/g, '');
                                localStorage.setItem(key, newValue);
                            }
                        }
                    }
                    localStorage.setItem('selected_business_profile', JSON.stringify({
                        corporate_id: null,
                        branch_id: null,
                        merchant_id: null
                    }));
                    if (!merchantId) {
                        await performAuthCheck();
                    }
                }
                if (registerStateFromUrl === '0') {
                    registerState.value = true;
                    registerMessage.value = false;
                }
            } catch (error) {
                // Suppressed initialization error
            } finally {
                loading.value = false;
            }
            api.request('get', `/api/public/corporate-id`)
                .then(async (response) => {
                const corporateId = response.data.data;
                const s3Url = process.env.VUE_APP_S3_BUCKET;
                const loginBackgroundExists = await checkImage(`${s3Url}user_assets/${corporateId}/loginBackground.png`);
                const extensions = ['png', 'jpg', 'jpeg', 'webp'];
                let corporateLogoExists = false;
                let corporateLogoUrl = '';
                for (const ext of extensions) {
                    const logoUrl = `${s3Url}user_assets/${corporateId}/corporateLogo.${ext}`;
                    corporateLogoExists = await checkImage(logoUrl);
                    if (corporateLogoExists) {
                    corporateLogoUrl = logoUrl;
                    break;
                    }
                }
                if (loginBackgroundExists) {
                    loginBackground.value = `${s3Url}user_assets/${corporateId}/loginBackground.png`;
                    localStorage.setItem('loginBackground', loginBackground.value);
                } else {
                    loginBackground.value = '/img/temporary-login.png';
                    localStorage.setItem('loginBackground', loginBackground.value);
                }
                if (corporateLogoExists) {
                    corporateLogo.value = corporateLogoUrl;
                    localStorage.setItem('corporateLogo', corporateLogo.value);
                } else {
                    corporateLogo.value = '/img/icons/Color_Alternate-1024x381.png';
                    localStorage.setItem('corporateLogo', corporateLogo.value);
                }
                })
                .catch(() => {
                    loginBackground.value = '/img/temporary-login.png';
                    corporateLogo.value = '/img/icons/Color_Alternate-1024x381.png';
                });
            });
            onBeforeUnmount(() => {
                if (countdownInterval.value) {
                    clearInterval(countdownInterval.value);
                }
                window.removeEventListener('storage', handleStorageChange);
                window.removeEventListener('pageshow', handlePageShow);
            });

            // Tambahkan handleLoginError agar tidak error
            /**
             * Handles and displays login errors.
             * Resets the URL state to clear error parameters from the browser history.
             * 
             * @param {string} message - Error message to display
             */
            const handleLoginError = (message) => {
                passwordErrorMessage.value = message;
                const merchantId = route.query.merchant_id;
                const newUrl = merchantId ? `?merchant_id=${merchantId}` : '?';
                window.history.replaceState({}, '', newUrl);
            };
            /**
             * Navigates the user to the Sign Up page with appropriate parameters.
             */
            const goToSignUp = async () => {
                const ref = route.query.ref;
                if (ref) {
                    localStorage.setItem('register_ref_param', ref);
                }
                
                let targetMerchantId = merchant_id.value;
                if (!targetMerchantId && isNativePlatform.value) {
                    // Get from selected_business_profile first
                    const storedProfile = JSON.parse(localStorage.getItem('selected_business_profile') || '{}');
                    if (storedProfile.merchant_id && storedProfile.merchant_id !== 'member') {
                        targetMerchantId = storedProfile.merchant_id;
                    } else {
                        // Fetch merchant_id dynamically from tenant default-context
                        // (mengganti hardcode UUID yang tenant-specific)
                        try {
                            const response = await api.request('get', '/api/member/default-context');
                            targetMerchantId = response.data?.data?.merchant_id || null;
                        } catch (error) {
                            console.warn('[goToSignUp] Failed to fetch default-context, proceeding without merchant_id', error);
                            targetMerchantId = null;
                        }
                    }
                }

                const params = corporate_id.value && dashboard.value 
                    ? { merchant_id: corporate_id.value } 
                    : { merchant_id: targetMerchantId };
                
                const query = {};
                if (referral_code.value) {
                    query.referral = referral_code.value;
                }
                
                const destination = {
                    name: 'MemberSignUp',
                    params: params,
                    query: Object.keys(query).length > 0 ? query : undefined
                };
                
                router.push(destination);
            };


            /**
             * Opens the Privacy Policy modal and loads content.
             */
            const openPrivacyPolicy = async () => {
                try {
                    await store.dispatch('Policies/get_public_privacy_policy');
                    activeTab.value = 'privacy';
                    showPrivacyModal.value = true;
                } catch (error) {
                    activeTab.value = 'privacy';
                    showPrivacyModal.value = true;
                }
            };

            /**
             * Opens the Terms & Conditions modal and loads content.
             */
            const openTermsConditions = async () => {
                try {
                    await store.dispatch('Policies/get_public_terms_conditions');
                    activeTab.value = 'terms';
                    showPrivacyModal.value = true;
                } catch (error) {
                    activeTab.value = 'terms';
                    showPrivacyModal.value = true;
                }
            };

            /**
             * Closes the policies modal.
             */
            const closePrivacyModal = () => {
                showPrivacyModal.value = false;
            };
            // Expose to template
            return {
                email,
                password,
                loading,
                validation,
                validateLevel,
                validationEntity,
                merchant_id,
                validationMemberOnly,
                registerState,
                registerMessage,
                showPassword,
                branchLogo,
                autoLoginData,
                corporate_id,
                dashboard,
                otp,
                otpRequested,
                otpErrorMessage,
                redirectUrl,
                showCountdown,
                showRefreshButton,
                countdownMinutes,
                countdownSeconds,
                countdownInterval,
                isOtpMode,
                isProcessing,
                loginBackground,
                corporateLogo,
                passwordErrorMessage,
                activities,
                otpEmail,
                referral_code,
                isNativePlatform,
                isIosPlatform,
                forgotPasswordLink,
                signUpLink,
                formattedTime,
                setCorporateLogo,
                backgroundStyle,
                setLoadingState,
                autoLogin,
                switchToOtpMode,
                switchToLoginMode,
                startCountdown,
                resendOTP,
                login,
                logout,
                requestOtp,
                handleOtpFormSubmit,
                submitOtp,
                submitLogin,
                checkSessionOnLoad,
                loginWithGoogle,
                handleGoogleLoginSuccess,
                handleGoogleLoginError,
                handleAppleLoginSuccess,
                handleAppleLoginError,
                loginWithFacebook,
                loginWithLinkedin,
                performAuthCheck,
                clearAutoLoginData,
                checkImage,
                handleStorageChange,
                isLoggedIn,
                handleLoginError,
                currentYear,
                openPrivacyPolicy,
                openTermsConditions,
                showPrivacyModal,
                activeTab,
                closePrivacyModal,
                goToSignUp
            };
        }
    };
</script>
<style scoped>
.form-login {
    margin-top: 1%;
}
.row-wrapper {
    display: flex;
    width: 100%;
    height: 100vh;

}
#picture {
    align-items: center;
}
.col-8 {
    width: 66.66%;
    display: grid;
    align-items: center;
    position: relative;
    overflow: hidden;

}
.image {
    height: 50%;
    object-fit: contain;

    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    top: 25%;
    left: 0;
    right: 0;
    bottom: 0;
}
.feature-desc {
    block-size: 100%;
}
.col-4 {
    width: 33.33%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: white;
    height: 100vh;
    box-shadow: -10px 0 20px rgba(0, 0, 0, 0.1);
}
.card-body#login-card {
    display: grid;
    justify-content: center;
    font-size: small;
    height: 100%;
    margin: 20%;
    overflow: auto;
}
.logo-brand {
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}
#logo-brand {
    display: grid;
    width: 85%;
    padding-bottom: -10%;
}
#logo-brand-omnih {
  display: grid;
  width: 85%;
  padding-bottom: -10%;
}
.separator {
    border: none;
    height: 1px;
    background-color: gray;
    width: 100%;
    margin-top: 5%;
    margin-bottom: 1%;
}
#login, .card-title {
    font-size: 14px;
    font-weight: 600;
    color: gray;
    display: flex;
    text-align: center;
    justify-content: center;
}
#login-container {
    display: flex;
    margin-top: 6%;
    height: 30%;
    margin-bottom: 20px;
}
#login-container-not-web-temp {
  display: flex;
  margin-top: 20px;
  height: 30%;
}
.simple-footer {
    margin-top: 10px;
    text-align: center;
    color: #98a6ad;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
small {
    display: inline-block;
    width: 100%;
    text-align: center;
}
#login-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.login-button-container {
  margin-top: auto;
  margin-bottom: 20px;
}

.login-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  width: fit-content;
  font-size: 16px;
  color: white;
  background: linear-gradient(135deg, #ff416c, #ff4b2b);
  border-radius: 8px;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(255, 65, 108, 0.3);
  transition: background 0.3s ease, transform 0.3s ease;
}

.login-button:hover {
  background: linear-gradient(135deg, #ff6a00, #ee0979);
  transform: scale(1.05);
  color: white;
}

.native-login-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  width: 100%;
  max-width: 300px;
  font-size: 16px;
  color: white;
  background: linear-gradient(135deg, #ff416c, #ff4b2b);
  border: none;
  border-radius: 8px;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(255, 65, 108, 0.3);
  transition: background 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.native-login-button:active {
  background: linear-gradient(135deg, #ff6a00, #ee0979);
  transform: scale(0.98);
}

.spinner-position {
    margin-top: 10px;
}

#google-login-container {
    margin-top: 20px;
}

.google-login-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    width: fit-content;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-bottom: 10px;
}

.google-login-text {
    margin-left: 10px;
    font-size: 14px;
}

.divider-with-text {
    margin: 20px 0;
    text-align: center;
    color: #808080;
}

.simple-footer {
    text-align: center;
    margin-top: 20px;
    font-size: 12px;
    color: #808080;
}
@media (max-width: 768px) {
    #login-container-not-web-temp {
        margin-top: 20px; /* Adjust this if needed to avoid overlapping other elements */
    }

    .login-button {
        width: 100%; /* Ensure the button fills the available width on small screens */
        max-width: 300px; /* Set a max width to prevent it from getting too large */
        margin: 0 auto; /* Center it horizontally */
    }
    .col-8 {
        display: none;
    }
    .col-4 {
        width: 100%;
        max-width: 100%;
    }
    .row-wrapper {
        justify-content: center;
    }
}
.custom-alert {
  position: relative;
  background: linear-gradient(135deg, #ff4b2b, #ff416c);
  color: white;
  padding: 15px 20px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(255, 65, 108, 0.5);
  animation: fadeInDown 0.6s ease-out;
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.alert-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.alert-icon {
  font-size: 24px;
  margin-right: 15px;
  animation: pulse 2s infinite;
}
p {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.signup-prompt-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 100%;
}
.signup-text {
  color: #808080;
  font-size: 14px;
}
.signup-button-inline {
  color: #e74c3c !important;
  font-weight: bold !important;
  text-decoration: none !important;
  padding: 0 5px !important;
  font-size: 14px !important;
}
.signup-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
  max-width: 600px;
  padding: 2%;
  flex-wrap: nowrap;
}
.signup-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}
@media (max-width: 768px) {
  .signup-container {
    flex-direction: column;
    text-align: center;
  }
  .signup-button {
    margin-top: 15px;
    width: 100%;
  }
  .card-body#login-card {
    display: grid;
    justify-content: center;
    font-size: small;
    height: 80%;
    margin: 20%;
    overflow: scroll;
  }
  .google-login-button {
    margin-top: 6%;
  }
}
@media (max-width: 1448px) {
  .signup-container {
    flex-direction: column;
    text-align: center;
  }
  .signup-button {
    margin-top: 15px;
    width: 100%;
  }
}
.divider-with-text {
  display: flex;
  align-items: center;
  text-align: center;
}
.divider-with-text::before,
.divider-with-text::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #ccc;
    margin: 0 10px;
}
.divider-with-text span {
    font-size: 14px;
    color: #666;
}
.no-underline {
  text-decoration: none;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
  -webkit-text-fill-color: black !important;
}
input:-moz-autofill {
  background-color: white !important;
  color: black !important;
}
input:-webkit-autofill:disabled {
  -webkit-box-shadow: 0 0 0 1000px #e9ecef inset !important;
  -webkit-text-fill-color: black !important;
}

input:-moz-autofill:disabled {
  background-color: #e9ecef !important;
  color: black !important;
}

input:disabled {
  background-color: #e9ecef !important;
  color: black !important;
}
@media (max-width: 375px) {
  #login-card {
      width: 100%;
      margin: auto;
  }
  .col-4 {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
  }
  .row-wrapper {
      flex-direction: column;
  }
  body, html {
      overflow-y: auto;
      height: 100%;
      margin: 0;
      padding: 0;
  }
  #app {
      height: auto;
      min-height: 100vh;
      padding-top: 0;
      box-sizing: border-box;
  }
  .card-body#login-card {
      overflow: visible;
      max-height: none;
      margin-top: 0;
      padding: 0;
  }
  .d-flex {
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .d-flex.justify-content-center {
      justify-content: center;
  }
  .google-login-button {
      width: 100%;
      margin-bottom: 10px;
      padding: 10px;
      font-size: 14px;
  }
  .google-login-text {
      margin-left: 10px;
  }
}
.google-login-button {
  display: flex;
  align-items: center;
  justify-content: center; 
  background-color: white;
  color: #5f6368;
  font-size: 15px;
  font-weight: 500;
  border: 1px solid #5f6368;
  border-radius: 24px;
  padding: 10px 20px;
  cursor: pointer;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 300px;
  margin: 10px 0;
  transition: box-shadow 0.3s ease;
}

/* Hover efek untuk meningkatkan interaksi */
.google-login-button:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

/* Ikon tetap diatur secara proporsional */
.google-icon {
  margin-right: 10px; /* Sesuaikan jarak antara ikon dan teks */
  height: 18px;
  width: 18px;
}

.otp-link {
  color: #ff416c; /* Warna teks putih */
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
}

.otp-link:hover {
  text-decoration: none;
  color: #ff416c;
  
}

/* Policies modal tab styling - same as sidebar */
.policies-tabs {
  display: flex;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
}

.tab-button {
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  background-color: transparent;
  color: #6c757d;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 3px solid transparent;
}

.tab-button:hover {
  background-color: #e9ecef;
  color: #495057;
}

.tab-button.active {
  color: #cb5b5b;
  background-color: #fff;
  border-bottom-color: #cb5b5b;
  font-weight: 600;
}

.modal-content {
  min-width: 500px !important;
}

.policy-content {
  padding-bottom: 1.5rem;
}

/* Policies Modal Responsive Styles */
.policies-modal-content {
  min-width: 500px;
}

/* Mobile Responsive for Policies Modal */
@media screen and (max-width: 768px) {
  .policies-modal-content {
    min-width: 90vw !important;
    max-width: 90vw !important;
    margin: 10px auto !important;
  }
  
  .policies-container {
    height: 60vh !important;
    max-height: 60vh !important;
    min-height: 300px !important;
  }
  
  .tab-content {
    height: calc(60vh - 60px) !important;
    max-height: calc(60vh - 60px) !important;
    padding: 1rem !important;
  }
  
  .tab-button {
    padding: 0.5rem 0.75rem !important;
    font-size: 0.85rem !important;
  }
}

@media screen and (max-width: 480px) {
  .policies-modal-content {
    min-width: 95vw !important;
    max-width: 95vw !important;
    margin: 5px auto !important;
  }
  
  .policies-container {
    height: 55vh !important;
    max-height: 55vh !important;
    min-height: 250px !important;
  }
  
  .tab-content {
    height: calc(55vh - 60px) !important;
    max-height: calc(55vh - 60px) !important;
    padding: 0.75rem !important;
  }
  
  .tab-button {
    padding: 0.4rem 0.5rem !important;
    font-size: 0.8rem !important;
  }
  
  .policies-tabs {
    flex-wrap: nowrap;
  }
}

@media screen and (max-width: 375px) {
  .policies-modal-content {
    min-width: 98vw !important;
    max-width: 98vw !important;
    margin: 2px auto !important;
  }
  
  .policies-container {
    height: 50vh !important;
    max-height: 50vh !important;
    min-height: 200px !important;
  }
  
  .tab-content {
    height: calc(50vh - 55px) !important;
    max-height: calc(50vh - 55px) !important;
    padding: 0.5rem !important;
  }
  
  .tab-button {
    padding: 0.35rem 0.4rem !important;
    font-size: 0.75rem !important;
  }
}

/* Modal backdrop responsive */
@media screen and (max-width: 768px) {
  .policies-modal .modal-dialog {
    margin: 10px !important;
    max-width: none !important;
  }
}
</style>